import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import DealerAdIframe from '../../dealer';
const DesktopDevPageArtStage = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Primis, ADUNIT_MAP['DesktopDevPageArtStageVideo'], safety, {
        placementId: 114276,
        vpContent: 'plembed35b9omrwtkip',
        verticalOffset: 98,
        clientOnly: true,
        floatDirection: 'bl',
        floatWidth: 300
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    if (advertIsOff === 'fallback') {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '340px',
                height: '191px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['DesktopDevPageArtStageVideo'],
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({
        style: {
            aspectRatio: '16/9'
        }
    }, slotAttr));
}, adunitMemo);
DesktopDevPageArtStage.displayName = 'DesktopDevPageArtStage';
export default DesktopDevPageArtStage;
